import { useActiveVerseStore } from '@/verse/active-verse.store';

const netLog: (...args: unknown[]) => void = console.log.bind(console);

/**
 * RPC client for admin-app. Reads the active GameServer from useActiveVerseStore
 * and forwards calls to `server.remoteFunction(fn, args)`.
 *
 * Differs from src/client/rpc-client.ts:
 *  - No reconnect loop (VerseConnectionManager owns lifecycle)
 *  - No guest-block allowlist (admins are never guests)
 *  - Throws fast if no active verse
 *
 * NOTE: V8 SDK 는 함수명당 초당 10회(sliding window) 호출만 허용한다. 여러 건을
 * 묶어 부르는 호출자(퍼널/출석 분포)는 Promise.all 로 동시에 던지지 말고
 * for-await 로 *한 건씩 응답을 받은 뒤 다음* 을 호출해야 한다.
 */
export const AdminRPCClient = {
  async call<T>(fn: string, args?: unknown[]): Promise<T> {
    const conn = useActiveVerseStore.getState().manager?.current;
    if (!conn) throw new Error(`[AdminRPCClient] no active verse for call ${fn}`);
    netLog(`[admin-rpc] ${fn} →`, args ?? '(no args)');
    const t0 = performance.now();
    try {
      const result = await conn.server.remoteFunction(fn, args);
      netLog(`[admin-rpc] ${fn} ← (${Math.round(performance.now() - t0)}ms)`, result);
      return result as T;
    } catch (err) {
      console.error(`[admin-rpc] ${fn} ✗ (${Math.round(performance.now() - t0)}ms)`, err);
      throw err;
    }
  },
};
